<app-task-detail-content
    [taskData]="taskMgmtDetails"
    [context]="'dialog'"
    (saved)="onSaved($event)"
    (cancelled)="onCancelled()">
</app-task-detail-content>
